<div class="dashboarditem-container {{cssClass}}" title="">
  <!-- <div class="dashboarditem-title">{{title}}</div> -->
  <div class="dashboarditem-content hv-center">
    <ng-content></ng-content>
  </div>
</div>
